export const getFormattedDateFromUnixTime = (unixTime: any) => {
    const date = new Date(unixTime * 1000);
    return new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(date);
}

